import { call, put, takeLatest } from 'redux-saga/effects';
import { getEventsLog } from 'api/EventsLogAPI';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import type { EventLog } from './types';

/**
 * fetchEventsLog
 * Saga for fetching recent event logs
 */

export function* fetchEventsLog() {
  try {
    const data: EventLog[] = yield call(getEventsLog);
    yield put(actions.fetchEventsLogResponse(data));
  } catch (error) {
    const message = `Please try again later. If the problem persists, contact your CSM.`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_EVENTS_LOG_REQUEST, fetchEventsLog)]);
